module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJElEQVQ4y2NgGDTgPxCRgoeKATBAfwNwAfoZMPBhMDQT0oABANCpRshZBDplAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CH.png
// module id = 1108
// module chunks = 0